import React from "react";
import { IconButton, useMediaQuery } from "@mui/material";
import icon_information from "assets/images/icon_information.svg";
// import asterikIcon from "assets/images/asterik.svg";
// import daggerIcon from "assets/images/dagger.svg";
import { DaggerSvgIcon } from "helpers/CustomSVGGauge";

const SVGCurvedText = (props) => {
  const matches = useMediaQuery("(max-width:500px)");
  const colorSchemeJson = localStorage.getItem("colorSchemeJson");

  const colorScheme = colorSchemeJson ? JSON.parse(colorSchemeJson) : {};

  const {
    // dimensions = "M0 40, Q70 20, 140 40",
    dimensions = "M0,40 Q70,20 140,40",
    title,
    left,
    top,
    degree,
    bottom,
    right,
    fontSize = 26,
    fontFamily = matches ? "Lato-Semibold" : "Lato-Regular",
    titleColor = "#051a28",
    // textStartPoint = 30,
    // textEndPoint = 50,
    showSecondCurve,
    secondCurveTitle,
    secondCurveLeft,
    secondCurveTop,
    secondCurveDegree,
    secondCurveBottom,
    secondCurveRight,
    secondCurveFontSize = 26,
    // secondCurveTextStartPoint = 30,
    // secondCurveTextEndPoint = 50,
    secondTitleColor = "#fff",
    secondTitleFontFamily = matches ? "Lato-Semibold" : "Lato-Regular",
    //unicode,
    showInfoICon,
    onButtonClick,
    showDagger,
    getSavings = null,
    id = "",
    x = id === "copay_quadrant" ? "55%" : "50%",
    y = "50%",
    x1 = "40%",
    y1 = "40%",
  } = props;
  return (
    <>
      {showSecondCurve ? (
        <span
          style={{
            position: "absolute",
            left: secondCurveLeft,
            top: secondCurveTop,
            right: secondCurveRight,
            bottom: secondCurveBottom,
            zIndex: 10,
            height: matches ? 60 : 60,
            width: matches ? 92 : 140,
            transform: `rotate(${secondCurveDegree}deg)`,
          }}
        >
          <div
            style={{
              display: "inline-block",
              width: matches ? 92 : 140,
              height: matches ? 60 : 60,
              position: "relative",
            }}
          >
            <svg
              id="mysvg1"
              viewBox="0 0 140 60"
              preserveAspectRatio="xMidYMid meet"
            >
              <path
                id={secondCurveTitle}
                d={dimensions}
                fill="none"
                stroke="none"
              />
              <text
                x={showInfoICon ? "45%" : "50%"}
                y={showInfoICon ? "45%" : "50%"}
                dominantBaseline="top"
                textAnchor="middle"
              >
                <textPath
                  xlinkHref={`#${secondCurveTitle}`}
                  style={{
                    fontSize: secondCurveFontSize,
                    fill: secondTitleColor,
                    fontFamily: secondTitleFontFamily,
                  }}
                >
                  {secondCurveTitle}
                </textPath>
              </text>
            </svg>
          </div>
        </span>
      ) : (
        ""
      )}
      <span
        style={{
          position: "absolute",
          left: left,
          top: top,
          right: right,
          bottom: bottom,
          zIndex: 10,
          height: matches ? 60 : 60,
          width: matches ? 92 : 140,
          transform: `rotate(${degree}deg)`,
        }}
      >
        <div
          style={{
            display: "inline-block",
            width: matches ? 92 : 140,
            height: matches ? 60 : 60,
            position: "relative",
          }}
        >
          <svg
            id="mysvg2"
            viewBox="0 0 140 60"
            preserveAspectRatio="xMidYMid meet"
          >
            <path id={title} d={dimensions} fill="none" stroke="none" />
            <text
              x={showInfoICon ? x1 : x}
              y={showInfoICon ? y1 : y}
              dominantBaseline="top"
              textAnchor="middle"
            >
              <textPath
                onClick={() => {
                  if (getSavings != null) {
                    getSavings();
                  }
                }}
                xlinkHref={`#${title}`}
                style={{
                  fontSize: fontSize,
                  fill: titleColor,
                  fontFamily: fontFamily,
                  cursor: getSavings != null ? "pointer" : undefined,
                }}
              >
                {title}
              </textPath>
            </text>
          </svg>
          {showInfoICon ? (
            <IconButton
              onClick={() => onButtonClick()}
              sx={{
                position: "absolute",
                right: matches ? -10 : 0,
                top: matches ? 0 : "5px",
                transform: matches ? "rotate(10deg)" : "rotate(14deg)",
              }}
            >
              {/* <InfoOutlinedIcon
                sx={{ color: "white", backgroundColor: "#11952A", borderRadius: "50%" }}
              /> */}
              <img
                src={icon_information}
                alt="i"
                style={{ width: matches ? "20px" : undefined }}
              />
            </IconButton>
          ) : null}
          {showDagger ? (
            <DaggerSvgIcon
              style={{
                opacity: "0.7",
                width: matches ? "7px" : "10px",
                position: "absolute",
                right: matches ? "5px" : "10px",
                fontSize: "10px",
                top: matches ? "7px" : "15px",
                transform: "rotate(-210deg)",
              }}
              color={`${colorScheme?.gaugeColor?.wedgeTextColor}`}
            />
          ) : // <img
          //   src={daggerIcon}
          //   alt="i"
          //   style={{
          //     opacity: "0.7",
          //     width: matches ? "7px" : "10px",
          //     position: "absolute",
          //     right: matches ? "5px" : "10px",
          //     fontSize: "10px",
          //     top: matches ? "7px" : "15px",
          //     transform: "rotate(-210deg)",
          //   }}
          // />
          null}
        </div>
      </span>
    </>
  );
};
export default React.memo(SVGCurvedText);
